/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：242__part-0
 */

"use strict"

import { p, f, h, m } from "./242__part-1"
import { v, b } from "./242__part-2"
var r = {}
Object.defineProperty(r, "borderColorEnhance", {
  get: function () {
    return p
  }
})
Object.defineProperty(r, "backgroundColorEnhance", {
  get: function () {
    return f
  }
})
Object.defineProperty(r, "defaultContainedError", {
  get: function () {
    return h
  }
})
Object.defineProperty(r, "defaultOutlineError", {
  get: function () {
    return m
  }
})
var o = {}
Object.defineProperty(o, "buttonPress", {
  get: function () {
    return v
  }
})
var i = {}
Object.defineProperty(i, "checkNormal", {
  get: function () {
    return b
  }
})
export { r }
export { o }
export { i }
